import { createFileRoute } from '@tanstack/react-router';
import LineupsPage from '../../../../../../pages/lineups/LineupsPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/lineups/'
)({
  component: LineupsPage
});
